import { del, get, post } from "../../utils/fetchAPI";

// Seeded defaults plus anything this doctor added themselves.
export const getOccupations = async (doctorId, search = "") => {
  const params = new URLSearchParams();
  if (doctorId) params.append("doctorId", doctorId);
  if (search) params.append("search", search);
  const query = params.toString();
  const res = await get(`/occupation/list${query ? `?${query}` : ""}`);
  return res;
};

export const createOccupation = async (payload) => {
  const res = await post(`/occupation/create`, payload);
  return res;
};

export const deleteOccupation = async (occupationId) => {
  const res = await del(`/occupation/delete/${occupationId}`);
  return res;
};
